import { Card, DatePicker, Flex, Input, Skeleton } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  formatCurrency,
  formatWithCommas,
  getUserType,
} from "../../assets/helpers";
import ActionCodesModal from "../../components/ActionCodesModal/ActionCodesModal";
import ActionCodeTable from "../../components/TelecallersTable/ActionCodeCoverageTable";
import FilterDropdown from "../../Reuseable/actionHeader/Filter";
import BarChart from "../../Reuseable/Barchart/Barchart";
import DonutChart from "../../Reuseable/DonutChart/DonutChart";
import DonutChartSkeleton from "../../Reuseable/DonutChart/DonutChartSkeleton/DonutChartSkeleton";
import LineChart from "../../Reuseable/LineChart/LineChart";
import OverviewDonut from "../../Reuseable/OverviewDonut/OverviewDonut";
import ReusableTable from "../../Reuseable/ReusableTable/ReusableTable";
import BarChartSkeleton from "../../Reuseable/Skeleton/BarchartSkeleton";
import StatsCard from "../../Reuseable/StatsCard/StatsCard";
import {
  fetchDashboard,
  fetchDashboardOverview,
  fetchPerformanceReportTable,
  fetchSupervisorReportOverview,
  fetchTeamleadOverview,
} from "../../store/dashboardSlice";
import { clearQuery, fetchUserFilters, setQuery } from "../../store/filters";
import {
  fetchTelecallerActionCodes,
  fetchTelecallerDashboard,
  fetchTelecallerReport,
} from "../../store/telecaller/telecallerDashboard";
import "./DashboardPage.scss";
import IntensityCards from "../../components/BankDashboardComp/IntensityCards/IntensityCards";
import { fetchCaseIntencity } from "../../store/portfolioSlice";
import { useNavigate } from "react-router-dom";
import StaticSummaryCard from "./RecoveryCard";
import SummaryCard from "./RecoveryCard";
import { TelecallerPerformanceModal } from "../../components/TelecallerPerformanceModal/TelecallerPerformanceModal";

const DashboardPage = React.memo(() => {
  const {
    data: dashboardData,
    loading,
    overview,
    overviewLoading,
    supervisorReportCoverageChart,
    teamLeadOverviewChart,
    team_lead_loading,
    supervisorReportLoading,
    performance_report_table_loading,
    performance_report_table,
  } = useSelector((state) => state.dashboard);
  const { format } = useSelector((state) => state.priceFormat);
  const { query } = useSelector((state) => state.filters);
  const {
    tele_dashboard,
    tele_dash_loading,
    tele_report_overview,
    tele_report_overview_loading,
  } = useSelector((state) => state.telecallerDashboard);
  const { user } = useSelector((state) => state.auth);
  const {
    bankOverview,
    bankOverviwLoading,
    case_intensity_counts,
    case_intensity_counts_loading,
    Monthly_ptp,
    Monthly_ptp_loading,
  } = useSelector((state) => state?.portfolio);
  const [performancePagination, setPerformancePagination] = useState({
    page: 1,
    page_size: 5,
  });
  const dispatch = useDispatch();
  console.log(performance_report_table, 'performance_report_table')

  const colors = useMemo(
    () => [
      "#3070F0",
      "#8FC4FF",
      "#9E80FF",
      "#FFCB72",
      "#7EE0E0",
      "#00C7C7",
      "#007272",
      "#F682C9",
      "#64C75A",
      "#C3AFFF",
      "#A060DC",
      "#F15A41",
      "#F8B7F8",
      "#3070F0",
      "#8FC4FF",
      "#9E80FF",
      "#FFCB72",
      "#7EE0E0",
      "#00C7C7",
      "#007272",
    ],
    [],
  );

  const getReport = (userType) => {
    switch (userType) {
      case "telecaller":
        return tele_report_overview ?? null;
      case "supervisor":
      case "agency":
        return overview ?? null;
      default:
        return null;
    }
  };
  const [selectedFilter, setSelectedFilter] = useState("Performance");
  const [openActionCodes, setOpenActionCodes] = useState(false);
  const [performanceReportRowData, setPerformanceReportRowData] = useState(null);

  const teamLeadStats = useMemo(
    () => teamLeadOverviewChart?.Stats || {},
    [teamLeadOverviewChart],
  );

  const overviewData = useMemo(
    () => [
      teamLeadStats.resolved?.count || 0,
      teamLeadStats.pending?.count || 0,
      teamLeadStats.allocated?.count || 0,
    ],
    [teamLeadStats],
  );

  const labels = useMemo(() => ["Resolved", "Pending", "Allocated"], []);
  const overviewColors = useMemo(() => ["#36A546", "#FFA52F", "#1F77F5"], []);
  const centerValue = useMemo(
    () => teamLeadStats?.allocated?.percentage || 0,
    [teamLeadStats],
  );

  const categories = useMemo(
    () =>
      supervisorReportCoverageChart?.monthly_data?.map((m) =>
        m.month?.toUpperCase().slice(0, 3),
      ) || [],
    [supervisorReportCoverageChart],
  );

  const seriesData = useMemo(
    () => [
      {
        name: "RESOLVED",
        data:
          supervisorReportCoverageChart?.monthly_data?.map((m) => m.resolved) ||
          [],
      },
      {
        name: "PENDING",
        data:
          supervisorReportCoverageChart?.monthly_data?.map((m) => m.pending) ||
          [],
      },
      {
        name: "ALLOCATED",
        data:
          supervisorReportCoverageChart?.monthly_data?.map(
            (m) => m.allocated,
          ) || [],
      },
    ],
    [supervisorReportCoverageChart],
  );

  const dropdownOptions = useMemo(
    () => [
      // { label: "Coverage", value: "Coverage" },
      { label: "Performance", value: "Performance" },
    ],
    [],
  );

  const validPerformanceTable = [
    ...(performance_report_table?.results ?? []),
    ...(performance_report_table?.total
      ? [performance_report_table.total]
      : []),
  ];

  const values = [20, 15, 10, 12, 8, 14, 10, 50, 30, 18, 25, 12, 33];
  const total = values.reduce((a, b) => a + b, 0);

  // field agent bar chart
  const fieldAgentBarCategories = useMemo(
    () =>
      getReport(getUserType(user))?.field_agent_report?.codes?.map(
        (item) => item.label,
      ) || [],
    [overview, tele_report_overview],
  );

  const fieldAgentBarValues = useMemo(
    () =>
      getReport(getUserType(user))?.field_agent_report?.codes?.map(
        (item) => item.count,
      ) || [],
    [overview, tele_report_overview],
  );

  const fieldAgentDonutValues = useMemo(
    () =>
      getReport(getUserType(user))?.field_agent_report?.codes?.map(
        (item) => item.percent,
      ) || [],
    [overview, tele_report_overview],
  );

  const fieldAgentDonutLabels = useMemo(
    () =>
      getReport(getUserType(user))?.field_agent_report?.codes?.map(
        (item, index) => ({
          code: item?.code,
          name: item?.label,
        }),
      ) || [],
    [overview, tele_report_overview],
  );

  // telecaller bar chart
  const telecallerBarCategories = useMemo(
    () =>
      getReport(getUserType(user))?.telecaller_report?.codes?.map(
        (item) => item.code,
      ) || [],
    [overview, tele_report_overview],
  );

  const telecallerBarValues = useMemo(
    () =>
      getReport(getUserType(user))?.telecaller_report?.codes?.map(
        (item) => item.count,
      ) || [],
    [overview, tele_report_overview],
  );

  const telecallerDonutValues = useMemo(
    () =>
      getReport(getUserType(user))?.telecaller_report?.codes?.map(
        (item) => item.percent,
      ) || [],
    [overview, tele_report_overview],
  );

  const telecallerDonutLabels = useMemo(
    () =>
      getReport(getUserType(user))?.telecaller_report?.codes?.map((item) => ({
        code: item.code,
        name: item?.label,
      })) || [],
    [overview, tele_report_overview],
  );

  const [selectedStat, setSelectedStat] = useState("Overview");

  const handleFilterChange = useCallback((value) => {
    setSelectedFilter(value);
  }, []);

  const handleStatChange = useCallback((value) => {
    setSelectedStat(value);
  }, []);

  // dashboardActions.js
  useEffect(() => {
    dispatch(fetchDashboard(query));
    dispatch(fetchDashboardOverview(query));
    dispatch(fetchSupervisorReportOverview(query));
    dispatch(fetchTeamleadOverview(query));
    dispatch(
      fetchPerformanceReportTable({
        ...query,
        page: performancePagination.page,
        page_size: performancePagination.page_size,
      }),
    );
    dispatch(fetchTelecallerActionCodes());
    dispatch(fetchCaseIntencity());
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    dispatch(clearQuery());
    dispatch(fetchUserFilters());
  }, [dispatch]);

  const renderWithSkeleton = (text, fallback) => {
    if (performance_report_table_loading) {
      return <Skeleton.Input size="small" active />;
    }
    if (text === "Total") {
      return <span style={{ fontWeight: "bold" }}>{text}</span>;
    }

    // ✅ Only treat undefined, null, or empty string as missing — but allow 0
    if (text === undefined || text === null || text.toString().trim() === "") {
      return fallback || "NA";
    }

    return typeof text === "number" ? formatWithCommas(text) : text;
  };

  const columns = [
    {
      title: "Agent Name",
      dataIndex: "agent_name",
      key: "agent_name",
      render: (_, record) =>
        renderWithSkeleton(record?.agent_name, record?.username),
    },
    {
      title: "Allocated Cases",
      dataIndex: "allocated_cases",
      key: "allocated_cases",
      render: (text, record) => renderWithSkeleton(text),
    },
    {
      title: `Today Calls (${performance_report_table?.results?.[0]?.today_date || "NA"})`,
      dataIndex: "today_calls",
      key: "today_calls",
      render: (text) => renderWithSkeleton(text),
    },
    {
      title: `Yesterday Calls (${performance_report_table?.results?.[0]?.yesterday_date || "NA"})`,
      dataIndex: "yesterday_calls",
      key: "yesterday_calls",
      render: (text) => renderWithSkeleton(text),
    },
    {
      title: `Average Calls (Till Date)`,
      dataIndex: "average_calls_till_date",
      key: "average_calls_till_date",
      render: (text) => renderWithSkeleton(text),
    },
    {
      title: "This Month Calls",
      dataIndex: "this_month_calls",
      key: "this_month_calls",
      render: (text) => renderWithSkeleton(text),
    },
    {
      title: "Total Calls",
      dataIndex: "total_calls",
      key: "total_calls",
      render: (text) => renderWithSkeleton(text),
    },
  ];
  const columns2 = [
    {
      title: "Agent Name",
      dataIndex: "agent_name",
      key: "agent_name",
      render: (text, record) =>

        renderWithSkeleton(record?.agent_name || "Total", record?.username),
    },
    {
      title: `Paid Amount`,
      dataIndex: "paid_amount",
      key: "paid_amount ",
      onCell: (record) => {
        console.log(record?.paid_amount, 'ssssssss');
      },
      render: (text, record) => (<span
        style={{ cursor: "pointer" }}
        onClick={() => {
          handlePerformanceReportRowClick(text, record, 'paid_amount ');
        }}
      >
        {renderWithSkeleton(text)}
      </span>),
    },

    {
      title: `Paid`,
      dataIndex: "PAID",
      key: "PAID",
      onCell: (record) => {
        console.log(record?.PAID, 'ssssssss');
      },
      render: (text, record) => (<span
        style={{ cursor: "pointer" }}
        onClick={() => {
          handlePerformanceReportRowClick(text, record, 'PAID');
        }}
      >
        {renderWithSkeleton(text)}
      </span>),
    },
    {
      title: `PTP Amount`,
      dataIndex: "ptp_amount",
      key: "ptp_amount",
      render: (text, record) => (<span
        style={{ cursor: "pointer" }}
        onClick={() => {
          handlePerformanceReportRowClick(text, record, 'PTP');
        }}
      >
        {renderWithSkeleton(text)}
      </span>),
    },
    {
      title: `Promise to pay`,
      dataIndex: "PTP",
      key: "PTP",
      render: (text, record) => (<span
        style={{ cursor: "pointer" }}
        onClick={() => {
          handlePerformanceReportRowClick(text, record, 'PTP');
        }}
      >
        {renderWithSkeleton(text)}
      </span>),
    },
    {
      title: "Call Back",
      dataIndex: "CALLBACK",
      key: "CALLBACK",
      render: (text, record) => (<span
        style={{ cursor: "pointer" }}
        onClick={() => {
          handlePerformanceReportRowClick(text, record, 'CALLBACK');
        }}
      >
        {renderWithSkeleton(text)}
      </span>),
    },
    {
      title: `Non Contact`,
      dataIndex: "NON CONTACT",
      key: "NON CONTACT",
      render: (text, record) => (<span
        style={{ cursor: "pointer" }}
        onClick={() => {
          handlePerformanceReportRowClick(text, record, 'NON CONTACT');
        }}
      >
        {renderWithSkeleton(text)}
      </span>),
    },
    {
      title: "Ringing ",
      dataIndex: "RINGING",
      key: "RINGING",
      render: (text, record) => (<span
        style={{ cursor: "pointer" }}
        onClick={() => {
          handlePerformanceReportRowClick(text, record, 'RINGING');
        }}
      >
        {renderWithSkeleton(text)}
      </span>),
    },
  ];

  useEffect(() => {
    dispatch(fetchTelecallerDashboard(query));
    dispatch(fetchTelecallerReport(query));
  }, [dispatch, query]);
  const navigate = useNavigate();
  const handleNavigate = (item) => {
    dispatch(
      setQuery({
        intensity: item?.intensity,
      }),
    );
    navigate(`/allocation/cases`, {
      state: {
        preserveFilters: true,
      },
    });
  };

  const handleNotCalledNavigate = () => {
    dispatch(
      setQuery({
        not_called: true,
      }),
    );
    navigate(`/allocation/cases`, {
      state: {
        preserveFilters: true,
      },
    });
  };

  const getStats = (userType) => {
    switch (userType) {
      case "telecaller":
        return tele_dashboard ?? null;
      case "supervisor":
      case "agency":
        return dashboardData ?? null;
      default:
        return null;
    }
  };
  const handleRowClick = async (actionCode) => {
    setOpenActionCodes((prev) => ({
      ...prev,
      open: true,
      data: actionCode,
    }));
  };

  const handlePerformanceReportRowClick = (text, record, key) => {
    setPerformanceReportRowData((prev) => ({
      ...prev,
      open: true,
      params: {
        telecallers: [record?.id],
        code: key,
      }
    }))
  }
  console.log(performanceReportRowData, 'kldjflkdlfkdklfjdkfjdk');

  return (
    <Card className="dashboardPageMain">
      <Flex className="page_title">
        <h2>Dashboard</h2>
        <FilterDropdown variant="2" />
      </Flex>
      <div
        className="statsCardContainer"
        style={{ display: "flex", width: "100%" }}
      >
        <StatsCard
          {...{
            title: "Total Cases",
            value: formatWithCommas(
              getStats(getUserType(user))?.total_cases?.count,
            ),
            percent: dashboardData?.total_cases?.case_percent || "0%",
            amountLabel: "Amount Overdue",
            amount: formatCurrency(
              getStats(getUserType(user))?.total_cases?.amount_overdue,
              format,
            ),
            type: "default",
            loading: loading || tele_dash_loading,
          }}
        />
        <StatsCard
          {...{
            id: 1,
            title: "Allocated Stats",
            value: formatWithCommas(
              getStats(getUserType(user))?.allocated_stats?.total,
            ),
            type: "graph",
            loading: loading || tele_dash_loading,

            chart: [
              {
                name: "Telecaller",
                value: getStats(getUserType(user))?.allocated_stats
                  ?.telecaller_percentage,
              },
              {
                name: "Field Agent",
                value: getStats(getUserType(user))?.allocated_stats
                  ?.field_agent_percentage,
              },
            ],
          }}
        />
        <StatsCard
          {...{
            id: 1,
            loading: loading || tele_dash_loading,

            title: "Unallocated Stats",
            value: formatWithCommas(
              getStats(getUserType(user))?.unallocated_stats?.total,
            ),
            type: "graph",
            chart: [
              {
                name: "Telecaller",
                value: getStats(getUserType(user))?.unallocated_stats
                  ?.telecaller_percentage,
              },
              {
                name: "Field Agent",
                value: getStats(getUserType(user))?.unallocated_stats
                  ?.field_agent_percentage,
              },
            ],
          }}
        />

        <StatsCard
          {...{
            id: 1,
            title: "Coverage Stats",
            value: formatWithCommas(
              getStats(getUserType(user))?.coverage_stats?.total,
            ),
            type: "graph",
            loading: loading || tele_dash_loading,

            chart: [
              {
                name: "Telecaller",
                value: getStats(getUserType(user))?.coverage_stats
                  ?.telecaller_percentage,
              },
              {
                name: "Field Agent",
                value: getStats(getUserType(user))?.coverage_stats
                  ?.field_agent_percentage,
              },
            ],
          }}
        />

        {
          (user?.is_tc || user?.is_agency || user?.is_supervisor) && (
            <div
              style={{ cursor: "pointer" }}
              onClick={handleNotCalledNavigate}
            >
              <StatsCard
                {...{
                  title: `Not Called`,
                  value: formatWithCommas(getStats(getUserType(user))?.not_called),
                  // percent:  "0%",
                  amountLabel: "",

                  type: "default",
                  loading: loading || tele_dash_loading,
                }}
              />
            </div>
          )
        }

        <SummaryCard loading={loading || tele_dash_loading} data={getStats(getUserType(user))?.recovery_stats || {}} />

        {user?.is_tc && (
          <>
            <StatsCard
              {...{
                id: 1,
                title: "Telecaller Activity",
                // value: formatWithCommas(getStats(getUserType(user))?.telecaller_activity?.this_month_ptp),
                type: "graph",
                loading: loading || tele_dash_loading,
                info1: "This Month PTP",
                info2: "Last Month PTP",

                chart: [
                  {
                    name: "This Month PTP",
                    value: getStats(getUserType(user))?.telecaller_activity
                      ?.this_month_ptp,
                  },
                  {
                    name: "Last Month PTP",
                    value: getStats(getUserType(user))?.telecaller_activity
                      ?.last_month_ptp,
                  },
                ],
              }}
            />

            <StatsCard
              {...{
                id: 1,
                title: "Telecaller Activity",
                // value: formatWithCommas(getStats(getUserType(user))?.telecaller_activity?.this_month_ptp),
                type: "graph",
                loading: loading || tele_dash_loading,
                info1: "Todays Call",
                info2: "Yesterday Call",

                chart: [
                  {
                    name: "Today's Call",
                    value: getStats(getUserType(user))?.telecaller_activity
                      ?.todays_call,
                  },
                  {
                    name: "Yesterday Call",
                    value: getStats(getUserType(user))?.telecaller_activity
                      ?.yesterday_call,
                  },
                ],
              }}
            />
            <StatsCard
              {...{
                id: 1,
                title: "Collected Amount",
                // value: formatWithCommas(getStats(getUserType(user))?.telecaller_activity?.this_month_ptp),
                type: "graph",
                loading: loading || tele_dash_loading,
                footer: false,
                value: formatCurrency(
                  getStats(getUserType(user))?.telecaller_activity
                    ?.collected_amount,
                  format,
                ),

                chart: [
                  {
                    name: "Collected Amount",
                    value: getStats(getUserType(user))?.telecaller_activity
                      ?.collected_amount,
                  },
                ],
              }}
            />

            <StatsCard
              {...{
                id: 1,
                title: "Total PTP",
                // value: formatWithCommas(getStats(getUserType(user))?.telecaller_activity?.this_month_ptp),
                type: "graph",
                loading: loading || tele_dash_loading,
                footer: false,
                value: formatWithCommas(
                  getStats(getUserType(user))?.telecaller_activity?.total_ptp,
                ),
                chart: [
                  {
                    name: "Collected Amount",
                    value: getStats(getUserType(user))?.telecaller_activity
                      ?.total_ptp,
                  },
                ],
              }}
            />
          </>
        )}

        {(user?.is_tc || user?.is_agency || user?.is_supervisor) &&
          case_intensity_counts?.intensity?.map((item) => (
            <div
              style={{ cursor: "pointer" }}
              className={`${loading ? "loading-intensity-card" : ""}`}
              onClick={() => handleNavigate(item)}
            >
              <StatsCard
                {...{
                  title: `Intensity ${item.intensity}`,
                  value: formatWithCommas(item.count),
                  // percent:  "0%",
                  amountLabel: "",

                  type: "default",
                  loading: loading,
                }}
              />
            </div>
          ))}
      </div>

      {(user?.is_agency || user?.is_supervisor) && (
        <div className="dashboard-performance-report-table">
          <div className="dashboard-performance-table-heading">
            <h2>Telecaller Performance Report</h2>
            <div className="right_section">
              <Input
                onPressEnter={(e) => {
                  const value = e.target.value;
                  const params = {
                    ...performancePagination,
                    ...query,
                    search: value,
                  };
                  dispatch(fetchPerformanceReportTable(params));
                }}
                placeholder="Search"
              />
              <DatePicker
                onChange={(e) => {
                  const date = e ? e.format("YYYY-MM-DD") : null;
                  const params = {
                    ...performancePagination,
                    ...query,
                    date: date,
                  };
                  dispatch(fetchPerformanceReportTable(params));
                }}
              />
            </div>
          </div>

          <div className="performance-table-wrapper">
            <ReusableTable
              columns={columns}
              dataSource={
                performance_report_table_loading
                  ? Array(5).fill({})
                  : performance_report_table?.results
              }
              totalItems={performance_report_table?.count || 0}
              CurrentPageNo={performancePagination.page}
              currentPage={performancePagination.page}
              pageSize={performancePagination.page_size}
              triggerChange={(page, size) => {
                setPerformancePagination({ page, page_size: size });

                const query = {
                  page,
                  page_size: size,
                };

                dispatch(fetchPerformanceReportTable(query));
              }}
            />
            <ReusableTable
              columns={columns2}
              dataSource={
                performance_report_table_loading
                  ? Array(5).fill({})
                  : validPerformanceTable
              }
              totalItems={performance_report_table?.count || 0}
              CurrentPageNo={performancePagination.page}
              currentPage={performancePagination.page}
              pageSize={performancePagination.page_size}
              triggerChange={(page, size) => {
                setPerformancePagination({ page, page_size: size });

                const query = {
                  page,
                  page_size: size,
                };

                dispatch(fetchPerformanceReportTable(query));
              }}
              // onRowClick={handlePerformanceReportRowClick}
              rowClass="clickable-row"
            />
          </div>
        </div>
      )}

      {user?.is_tc && (
        <div className="telecaller-action-codes">
          <h2> Action Code Coverage</h2>
          <ActionCodeTable handleRowClick={handleRowClick} />
        </div>
      )}

      <Card className="content_graphs">
        <Flex className="main_title">
          <h2>Telecaller Report Overview</h2>
        </Flex>
        <Flex className="graph_container">
          {overviewLoading || tele_report_overview_loading ? (
            <BarChartSkeleton />
          ) : (
            <BarChart
              className="bargraph_box"
              title="Action Codes"
              categories={telecallerBarCategories}
              seriesData={telecallerBarValues}
              barColor="#FFA69E"
              height={277}
              tooltipText="Call Counts"
            />
          )}
          {overviewLoading || tele_report_overview_loading ? (
            <DonutChartSkeleton segments={9} />
          ) : (
            <DonutChart
              chartId="donut-telecaller"
              data={telecallerDonutValues}
              title="Telecaller Codes"
              labels={telecallerDonutLabels}
              colors={colors}
              total={overview?.telecaller_report?.total || 0}
              centerLabel="Received"
            />
          )}
        </Flex>
      </Card>
      <Card className="content_graphs second_column">
        <Flex className="main_title">
          <h2>Field Agent Report Overview</h2>
        </Flex>
        <Flex className="graph_container">
          {overviewLoading || tele_report_overview_loading ? (
            <BarChartSkeleton />
          ) : (
            <BarChart
              className="bargraph_box"
              title="Action Codes"
              categories={fieldAgentBarCategories}
              seriesData={fieldAgentBarValues}
              barColor="#FFA69E"
              height={277}
              tooltipText="Visit Counts"
            />
          )}
          {overviewLoading || tele_report_overview_loading ? (
            <DonutChartSkeleton segments={9} />
          ) : (
            <DonutChart
              chartId="donut-fieldagent"
              data={fieldAgentDonutValues}
              title="Field Agent Codes"
              labels={fieldAgentDonutLabels}
              colors={colors}
              total={overview?.field_agent_report?.total}
              centerLabel="Received"
            />
          )}
        </Flex>
      </Card>
      {user?.is_agency && (
        <Card className="overview_graphs">
          <Flex className="overview_container">
            {supervisorReportLoading ? (
              <BarChartSkeleton />
            ) : (
              <LineChart
                className="lineChartMain"
                title="Supervisor Report Overview"
                categories={categories}
                seriesData={seriesData}
                dropdownOptions={dropdownOptions}
                selectedOption={selectedFilter}
                onChange={handleFilterChange}
              />
            )}
            {team_lead_loading ? (
              <DonutChartSkeleton segments={9} />
            ) : (
              <OverviewDonut
                className="overviewdonutMain"
                title="Teamlead Report Overview"
                data={overviewData}
                labels={labels}
                colors={overviewColors}
                centerLabel="Allocated"
                centerValue={centerValue}
                dropdownOptions={[
                  // { label: "Stats", value: "Stats" },
                  { label: "Overview", value: "Overview" },
                ]}
                selectedOption={selectedStat}
                onChange={handleStatChange}
              />
            )}
          </Flex>
        </Card>
      )}
      <ActionCodesModal
        open={openActionCodes.open}
        data={openActionCodes?.data}
        setOpen={(val) =>
          setOpenActionCodes((prev) => ({
            ...prev,
            open: false,
          }))
        }
      />
      <TelecallerPerformanceModal params={performanceReportRowData?.params} open={performanceReportRowData?.open} setOpen={(val) => setPerformanceReportRowData((prev) => ({
        ...prev,
        open: false
      }))} />
    </Card>
  );
});

export default DashboardPage;
